import styled from "styled-components";
import { theme } from "../../../../../../helpers/theme";
import { PreliminaryAcceptanceButton } from "./preliminary-acceptance";
import { ResignationBar } from "./resignation-bar";

const reference1: string = "*Nasz konsultant skontaktuje się z Tobą w celu omówienia szczegółów realizacji. Będziesz mógł ją finalnie potwierdzić lub odrzucić w dalszym etapie procesu.";
const reference2: string = "*Oferta nie jest ofertą ostateczną w rozumieniu Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."


interface DecisionAreaProps {
    id_zamowienia: string,
    oferta_id: string,
    isFinalOffer?:boolean,

}

export const DecisionArea = ({ id_zamowienia, oferta_id, isFinalOffer }: DecisionAreaProps) => {

    return (
        <Container>
            <ButtonWraper>
                <ResignationBar
                    oferta_id={oferta_id}
                    id_zamowienia={id_zamowienia}
                    isFinalOffer={isFinalOffer} />
                <PreliminaryAcceptanceButton
                    oferta_id={oferta_id}
                    id_zamowienia={id_zamowienia}
                    isFinalOffer={isFinalOffer} />
            </ButtonWraper>
        </Container >
    );
};



const Container = styled.div`
padding:18px 0px;
`;
const ButtonWraper = styled.div`
display:flex;
flex-direction:row;
justify-content: space-between;
@media(max-width:360px){
    flex-direction:column;
    row-gap: 32px;
}
`;
const ReferencesWraper = styled.div`
margin-top:40px;
display:flex;
flex-direction:column;

`;
const Reference = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.normal};
font-size: 12px;
line-height: 18px;
color: ${theme.colors.gray01_secondaryText};
margin-bottom:16px;
`;